import _classCallCheck from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import Path from "./path.js";
/**
 * @class Simplified A* algorithm: all edges have a value of 1
 * @augments ROT.Path
 * @see ROT.Path
 */
var AStar = /*#__PURE__*/function (_Path) {
  _inherits(AStar, _Path);
  var _super = _createSuper(AStar);
  function AStar(toX, toY, passableCallback) {
    var _this;
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    _classCallCheck(this, AStar);
    _this = _super.call(this, toX, toY, passableCallback, options);
    _this._todo = [];
    _this._done = {};
    return _this;
  }
  /**
   * Compute a path from a given point
   * @see ROT.Path#compute
   */
  _createClass(AStar, [{
    key: "compute",
    value: function compute(fromX, fromY, callback) {
      this._todo = [];
      this._done = {};
      this._fromX = fromX;
      this._fromY = fromY;
      this._add(this._toX, this._toY, null);
      while (this._todo.length) {
        var _item = this._todo.shift();
        var id = _item.x + "," + _item.y;
        if (id in this._done) {
          continue;
        }
        this._done[id] = _item;
        if (_item.x == fromX && _item.y == fromY) {
          break;
        }
        var neighbors = this._getNeighbors(_item.x, _item.y);
        for (var i = 0; i < neighbors.length; i++) {
          var neighbor = neighbors[i];
          var x = neighbor[0];
          var y = neighbor[1];
          var _id = x + "," + y;
          if (_id in this._done) {
            continue;
          }
          this._add(x, y, _item);
        }
      }
      var item = this._done[fromX + "," + fromY];
      if (!item) {
        return;
      }
      while (item) {
        callback(item.x, item.y);
        item = item.prev;
      }
    }
  }, {
    key: "_add",
    value: function _add(x, y, prev) {
      var h = this._distance(x, y);
      var obj = {
        x: x,
        y: y,
        prev: prev,
        g: prev ? prev.g + 1 : 0,
        h: h
      };
      /* insert into priority queue */
      var f = obj.g + obj.h;
      for (var i = 0; i < this._todo.length; i++) {
        var item = this._todo[i];
        var itemF = item.g + item.h;
        if (f < itemF || f == itemF && h < item.h) {
          this._todo.splice(i, 0, obj);
          return;
        }
      }
      this._todo.push(obj);
    }
  }, {
    key: "_distance",
    value: function _distance(x, y) {
      switch (this._options.topology) {
        case 4:
          return Math.abs(x - this._fromX) + Math.abs(y - this._fromY);
          break;
        case 6:
          var dx = Math.abs(x - this._fromX);
          var dy = Math.abs(y - this._fromY);
          return dy + Math.max(0, (dx - dy) / 2);
          break;
        case 8:
          return Math.max(Math.abs(x - this._fromX), Math.abs(y - this._fromY));
          break;
      }
    }
  }]);
  return AStar;
}(Path);
export { AStar as default };